import axios from 'axios';
import { config } from '../config/env';
import { clearAuthSession, getTokenForApi } from './authStorage';

const api = axios.create({
  baseURL: config.api.baseURL,
  timeout: config.api.timeout,
  withCredentials: true,
});

// 请求拦截器：使用 blog app token 调用业务 API
api.interceptors.request.use(
  (cfg) => {
    const token = getTokenForApi();
    if (token && cfg.headers) {
      cfg.headers.Authorization = `Bearer ${token}`;
    }
    return cfg;
  },
  (error) => Promise.reject(error),
);

// 响应拦截器：401 时清除认证会话
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearAuthSession();
    }
    return Promise.reject(error);
  },
);

export default api; 